package com.shadowings.gero.data.lessons.chapter2

import androidx.compose.foundation.layout.Row
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.*

fun getChap2EOraContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_ci_siamo_abbiamo_completato_la_nostra_prima_e,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_ti_ricordi_la_misteriosa_iscrizione_luminosa_,
            face = Faces.Serious,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_ora_che_abbiamo_studiato_i_segni_delle_person,
            face = Faces.Happy,
            composable = {
                MdCWord("M23-L2", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_il_primo_segno_si_legge_nsut_e_significa_re_d,
            face = Faces.Surprised,
            composable = {
                MdCWord("M23", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_chiss_cosa_significa_l_intera_scritta,
            face = Faces.Serious,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_speriamo_di_incontrare_presto_il_prossimo_ger,
            face = Faces.Perfect,
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_nel_nostro_prossimo_viaggio_scopriremo_come_c,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_ma_prima_di_procedere_mettiti_alla_prova_con_,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_e_ora,
            content = Res.string.exp_content_andiamo,
            face = Faces.Perfect,
        )
    )
}
